import { MatterMassTortCustomFields } from "@/components/features/matter/custom-fields/MatterMassTortCustomFields";
import { FullPageCard, Text } from "@/components/ui";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/custom-fields",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const matterIdValue = String(matterId);
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterIdValue),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId: matterIdValue, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  const customFields = matter.massTortCustomFields;
  const hasMassTortCustomFields =
    customFields.length > 0 &&
    customFields.some((customField) => Boolean(customField.massTortId));

  if (!hasMassTortCustomFields) {
    return (
      <FullPageCard
        title="Custom fields not available."
        backButtonTitle="Back to matter overview"
        backButtonLink={`/matters/${matterIdValue}`}
      >
        <Text variant="subHeading">
          This matter does not have mass tort custom fields.
        </Text>
      </FullPageCard>
    );
  }

  return <MatterMassTortCustomFields matter={matter} />;
}
